module.exports = __webpack_public_path__ + "img/kerstin_cv_2.6ce1b560.jpg";